<template>
  <div class="home-wrapper">
    <div class="bg-orb bg-orb-1"></div>
    <div class="bg-orb bg-orb-2"></div>
    <div class="bg-orb bg-orb-3"></div>

    <div class="home-center">
      <div class="search-glass glass-strong">
        <div class="logo-area">
          <img src="@/assets/logoCard.png" alt="Fino Trato" class="home-logo" />
        </div>

        <div class="title-area">
          <h1 class="home-title">FINO TRATO</h1>
          <p class="home-subtitle">Identifique seu pet com segurança</p>
        </div>

        <div class="search-area">
          <div class="input-wrap">
            <span class="input-icon">
              <v-icon dark color="rgba(255,255,255,0.5)" size="20">mdi-magnify</v-icon>
            </span>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Digite o código do microchip..."
              class="glass-input home-input"
              @keyup.enter="buscarPet"
            />
          </div>

          <button
            class="btn-primary home-btn"
            @click="buscarPet"
            :disabled="!searchQuery.trim()"
          >
            <v-icon dark size="18">mdi-paw</v-icon>
            PESQUISAR PET
          </button>
        </div>

        <div class="home-links">
          <router-link to="/admin" class="home-link">
            <v-icon dark size="14">mdi-shield-account</v-icon>
            Painel Administrativo
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    buscarPet() {
      if (!this.searchQuery.trim()) return;
      this.$router.push(`/consultar-pet/${this.searchQuery.trim()}`);
    },
  },
};
</script>

<style scoped>
.home-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 20px;
}

.home-center {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
}

.search-glass {
  border-radius: 28px;
  padding: 44px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

.logo-area {
  display: flex;
  justify-content: center;
}

.home-logo {
  width: 100px;
  height: auto;
  filter: drop-shadow(0 4px 16px rgba(44, 183, 177, 0.4));
  user-select: none;
}

.title-area {
  text-align: center;
}

.home-title {
  font-size: 2rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 4px;
  margin: 0;
  text-shadow: 0 2px 12px rgba(44, 183, 177, 0.4);
}

.home-subtitle {
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.85rem;
  margin: 8px 0 0;
  letter-spacing: 0.5px;
}

.search-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  z-index: 1;
  display: flex;
}

.home-input {
  padding-left: 40px !important;
  border-radius: 12px !important;
  font-size: 0.9rem !important;
}

.home-btn {
  width: 100%;
  justify-content: center;
  border-radius: 12px;
  padding: 14px 24px;
  font-size: 0.9rem;
  letter-spacing: 1.5px;
}

.home-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

.home-links {
  display: flex;
  gap: 20px;
}

.home-link {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.78rem;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s ease;
}

.home-link:hover {
  color: rgba(255, 255, 255, 0.9);
}
</style>
